// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".with-yellow-div[data-v-62a461e6]{position:relative}.with-yellow-div[data-v-62a461e6]:before{content:\"\";background-color:#efd702;z-index:-1;position:absolute;top:50%;left:-10%;width:60%;height:60%}.right-side-sticky[data-v-62a461e6]{position:sticky;position:-webkit-sticky;top:55px;right:0;max-height:calc(100vh - 55px)}.fade-enter-active[data-v-62a461e6],.fade-leave-active[data-v-62a461e6]{-webkit-transition:opacity .5s ease;transition:opacity .5s ease}", ""]);
// Exports
module.exports = exports;
